// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2H6pt","overflowing":"ReadFullNote_overflowing__GQR-L"};